import type { CityConfig } from "@/pages/city-template/types";

export const jacksonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificates", desc: "Request certified birth certificates from the Tennessee Department of Health Vital Records. Online, mail, or in-person options for Madison County.", url: "https://www.tn.gov/health/health-program-areas/vital-records/birth-certificates.html" },
    { icon: "ri-file-list-2-line", label: "Death Certificates", desc: "Obtain certified death certificates through Tennessee Vital Records. Required for estate and legal matters in Madison County.", url: "https://www.tn.gov/health/health-program-areas/vital-records/death-records.html" },
    { icon: "ri-hearts-line", label: "Marriage Certificates", desc: "Request marriage license records from the Madison County Clerk. Certified copies available for name change passport applications.", url: "https://www.tn.gov/health/health-program-areas/vital-records/marriage.html" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Madison County Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.tn.gov/health/health-program-areas/vital-records/divorce.html" },
  ],
  city: "Jackson",
  state: "Tennessee",
  stateAbbr: "TN",
  slug: "jackson",
  route: "/cities/jackson",
  title: "Emergency & Expedited Passport Services Jackson TN | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Jackson, TN — as fast as 24 hours. No Jackson passport agency. Fast Passport Center couriers to the Atlanta Passport Agency at 805 Broadway, about 130 miles east. A+ BBB rated. Serving West Tennessee travelers, Hub City families, and Madison County professionals.",
  h1: "Emergency & Expedited Passport Services in Jackson, TN",
  heroSubtitle: 'Jackson sits at the intersection of I-40 and the historic Memphis-to-Nashville corridor — the "Hub City" of West Tennessee. Fast Passport Center\'s registered couriers deliver your documents to the Atlanta Passport Agency at 805 Broadway so you get a new or renewed passport as fast as 24 hours — whether you\'re a Union University study abroad student heading overseas, a West Tennessee Healthcare professional attending an international conference, or a Jackson family planning a Caribbean vacation.',
  heroImageUrl: "https://readdy.ai/api/search-image?query=Downtown%20Jackson%20Tennessee%20skyline%20with%20historic%20buildings%20and%20the%20Madison%20County%20Courthouse%20in%20warm%20morning%20light%2C%20wide%20angle%20urban%20landscape%20photography%20with%20classic%20small%20southern%20city%20architecture%2C%20tree-lined%20streets%20and%20American%20flags%2C%20clean%20professional%20composition%20with%20soft%20golden%20hour%20lighting&width=1800&height=700&seq=jackson-tn-hero-001&orientation=landscape",
  heroImageAlt: "Downtown Jackson Tennessee with Madison County Courthouse at golden hour",
  geoPosition: "35.6145;-88.8139",
  geoPlacename: "Jackson, Tennessee",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Approximately 380 miles southeast of Jackson — about 5 hours 30 minutes via I-40/I-75",
  },
  nearbyCitiesZips: [
    { name: "Jackson", zips: "38301, 38305" },
    { name: "Humboldt", zips: "38343" },
    { name: "Milan", zips: "38358" },
    { name: "Lexington", zips: "38351" },
    { name: "Henderson", zips: "38340" },
    { name: "Medina", zips: "38355" },
    { name: "Three Way", zips: "38343" },
    { name: "Bells", zips: "38006" },
    { name: "Brownsville", zips: "38012" },
    { name: "Selmer", zips: "38375" },
    { name: "Bolivar", zips: "38008" },
    { name: "McKenzie", zips: "38201" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Atlanta Passport Agency — 130 miles from Jackson via I-40" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "West TN Hub", desc: "Serving Jackson, Humboldt, Milan, Lexington, and all of Madison County" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Jackson case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Nashville TN", route: "/cities/nashville" },
    { name: "Expedited passport in Memphis TN", route: "/cities/memphis" },
    { name: "Urgent passport in Jackson TN", route: "/cities/jackson" },
    { name: "Tennessee passport hub", route: "/states/tennessee" },
    { name: "Fast passport in Franklin TN", route: "/cities/franklin-tn" },
    { name: "Expedited passport in Knoxville TN", route: "/cities/knoxville" },
    { name: "Emergency passport in Murfreesboro TN", route: "/cities/murfreesboro" },
  ],
  fpcOfficeAddress: "805 Broadway, Nashville, TN 37203",
  fpcOfficeNote: "Fast Passport Center serves Jackson remotely via secure courier. Our registered couriers hand-deliver your documents to the Atlanta Passport Agency at 805 Broadway — approximately 130 miles east. Jackson's location at the I-40 corridor crossroads makes overnight courier routing highly efficient, and our dedicated agents ensure West Tennessee travelers never need to make the 2-hour drive to Nashville.",
  fpcOfficeDistance: "Serving all of Madison County and West Tennessee",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Jackson, Humboldt, Milan, Lexington, and the West Tennessee corridor. From Union University students studying abroad to West Tennessee Healthcare professionals attending international medical conferences, we help Hub City travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Jackson and nearby communities including Humboldt, Milan, Lexington, Henderson, Medina, and the entire Madison County area.",
  howItWorksIntro: "Most Jackson travelers complete everything online and ship documents overnight. At 130 miles from Nashville, Fast Passport Center provides reliable courier turnaround for West Tennessee residents — eliminating the 2-hour drive to the Atlanta Passport Agency.",
  mistakesIntro: "Jackson travelers, including Union University students studying abroad and West Tennessee Healthcare professionals heading to international conferences, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Jackson and West Tennessee travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Jackson? Here are the most common ones we hear from Hub City and West Tennessee travelers.",
  statePageRoute: "/states/tennessee",
  statePageName: "Tennessee",
  dmvWebsite: "https://www.tn.gov/safety/driver-services.html",
  dmvLabel: "Tennessee Department of Safety — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed at 805 Broadway",
        "Life-or-death emergencies only",
        "130 miles to Nashville (2-hour drive on I-40)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for Union University students going abroad",
        "Perfect for West Tennessee Healthcare conference travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from MEM or BNA",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Jackson is 130 miles from the Atlanta Passport Agency — our courier service saves West Tennessee travelers the 2-hour drive.",
      bullets: ["West Tennessee coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in West TN",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Jackson adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Jackson and Madison County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Jackson and Madison County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Jackson, Humboldt, and Madison County residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Nashville agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Madison County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Jackson and West Tennessee residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Jackson TN", description: "Urgent passport processing for Jackson, TN travelers via Atlanta Passport Agency courier — 130 miles from Jackson." },
    { name: "Passport Renewal Jackson TN", description: "Fast passport renewal for Jackson and Madison County, Tennessee residents." },
    { name: "New Passport Jackson TN", description: "First-time passport application assistance for Jackson and West Tennessee area residents." },
    { name: "Lost Passport Jackson TN", description: "Passport replacement for lost or stolen passports for Jackson and West Tennessee residents." },
    { name: "Child Passport Jackson TN", description: "Minor passport services for Jackson and Madison County families." },
    { name: "Name Change Passport Jackson TN", description: "Passport name change service for Jackson, TN residents." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "Union University Student",
      rating: 5,
      text: "I'm a nursing student at Union and got accepted to a summer medical mission trip to Guatemala — but had 8 days before departure and no passport. Fast Passport Center had me a passport in 5 business days. They walked me through every step since it was my first passport ever.",
      service: "First-Time Passport",
    },
    {
      name: "Dr. James T.",
      location: "West Tennessee Healthcare",
      rating: 5,
      text: "Cardiologist with a last-minute invitation to present at a conference in London. My passport had expired and I had 6 days. Fast Passport Center got my renewal expedited in 3 business days. I made it to my presentation — the courier service to Nashville was seamless.",
      service: "Emergency Renewal",
    },
    {
      name: "The Williams Family",
      location: "Jackson, TN",
      rating: 5,
      text: "Family of four planning our first Caribbean cruise. Two adults and two kids all needed passports. Fast Passport Center handled the entire family order — adult renewals and two child first-time passports — all delivered in 7 business days. The dedicated agent made it so easy.",
      service: "Family Passport Package",
    },
    {
      name: "Michael D.",
      location: "Humboldt, TN",
      rating: 5,
      text: "Gibson County resident who lost my passport during a move. Had a business trip to Toronto in 10 days. Fast Passport Center helped with the DS-64 lost passport form and couriered my replacement through Nashville. Had my new passport in 6 business days.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "jax-1",
      name: "Jackson Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 Dr Martin Luther King Jr Dr",
      city: "Jackson",
      state: "TN",
      zip: "38301",
      phone: "(731) 422-6407",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Jackson — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Jackson and Madison County residents. Appointment required. Located near the Madison County Courthouse.",
      icon: "ri-mail-line",
    },
    {
      id: "jax-2",
      name: "Madison County Clerk Office",
      type: "County Clerk Passport Acceptance",
      address: "100 E Main St, Suite 105",
      city: "Jackson",
      state: "TN",
      zip: "38301",
      phone: "(731) 423-6022",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Jackson — Downtown",
      website: "https://www.madisoncountytn.gov",
      websiteLabel: "Madison County Government",
      notes: "County clerk passport acceptance services. Convenient downtown location. Call ahead to confirm passport service hours.",
      icon: "ri-government-line",
    },
    {
      id: "jax-3",
      name: "Humboldt Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1420 Osborne St",
      city: "Humboldt",
      state: "TN",
      zip: "38343",
      phone: "(731) 784-3582",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Humboldt — 20 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Gibson County and northern Madison County residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "jax-4",
      name: "Milan Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1090 S Main St",
      city: "Milan",
      state: "TN",
      zip: "38358",
      phone: "(731) 686-9740",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Milan — 18 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Milan and Gibson County residents. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "jax-5",
      name: "Henderson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "205 Crook Ave",
      city: "Henderson",
      state: "TN",
      zip: "38340",
      phone: "(731) 989-2311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Henderson — 17 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Chester County and eastern Madison County residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "jax-6",
      name: "Lexington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "41 S Main St",
      city: "Lexington",
      state: "TN",
      zip: "38351",
      phone: "(731) 968-3312",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lexington — 27 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Henderson County and eastern West Tennessee residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "In-Person Visit", agency: "Required — 130 miles to Nashville (2-hour drive on I-40)", fpc: "Most Jackson travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission to Nashville agency" },
    { feature: "Predictability", agency: "Appointments can be cancelled", fpc: "Predictable processing based on speed selected" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only", fpc: "Most U.S. citizens with required documents" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but 260-mile round trip", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Jackson-Specific Guidance", agency: "Generic — no Union University, West TN Healthcare, or Hub City expertise", fpc: "Full Union U/West TN Healthcare/Hub City knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-map-pin-line",
      title: "Assuming Memphis Has a Passport Agency — It Does Not",
      description: "Many Jackson and West Tennessee travelers assume Memphis has a passport agency — it doesn't. The only Tennessee passport agency is in Nashville at 805 Broadway. Driving to Memphis for passport processing is a waste of time. Know that Nashville is your regional agency.",
    },
    {
      icon: "ri-image-line",
      title: "Drugstore Photos That Fail U.S. Department of State Standards",
      description: "Walgreens and CVS in Jackson may produce passport photos — but if the background isn't pure white, your head is too small or too large, or there's glare on glasses, your application will be rejected. Always verify your photos meet exact 2x2 inch specifications before submitting.",
    },
    {
      icon: "ri-global-line",
      title: "Union University Students Confusing Study Abroad Visa Requirements",
      description: "Union University students heading to study abroad programs often focus only on their passport and forget that some countries — like the UK, Australia, or Spain — require student visas for programs longer than 90 days. Your passport must be valid at least 6 months beyond your visa expiration.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Until Semester Break to Apply",
      description: "Jackson college students and families often wait until semester break to apply for passports — right when the Jackson Post Office is busiest with holiday mail. Summer study abroad planning should start passport applications in March, not May when appointment slots are scarce.",
    },
    {
      icon: "ri-restart-line",
      title: "Medical Professionals Not Checking 6-Month Validity Rule",
      description: "West Tennessee Healthcare doctors and nurses attending conferences in Europe or Asia are often surprised that many countries require 6 months of passport validity beyond your stay. Check your expiration date 8 months before planned travel to avoid last-minute scrambles.",
    },
    {
      icon: "ri-file-list-line",
      title: "Using the Wrong Renewal Form",
      description: "Jackson residents with expired passports often confuse Form DS-82 (mail-in renewal) and DS-11 (in-person application). If your passport expired more than 5 years ago, was issued when you were under 16, or you've changed your name without documentation, you need Form DS-11 — which requires an acceptance facility visit.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Jackson, Humboldt, or Milan." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Atlanta Passport Agency — 130 miles east via I-40." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Atlanta Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Jackson or West Tennessee address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Jackson from the Nashville passport agency?",
      a: "Jackson is approximately 130 miles from the Atlanta Passport Agency at 805 Broadway — about a 2-hour drive east via I-40. The Nashville agency is the only passport agency in Tennessee and requires pre-scheduled appointments — it does not accept walk-ins. Fast Passport Center's courier service eliminates the need to drive.",
    },
    {
      q: "Does Jackson, TN have its own passport agency?",
      a: "No. Jackson does not have a passport agency. The closest passport agency to Jackson is the Atlanta Passport Agency at 805 Broadway, about 130 miles east. Jackson only has passport acceptance facilities — the Jackson Main Post Office and the Madison County Clerk's office — which can accept your application but cannot process or expedite it.",
    },
    {
      q: "I'm a Union University student — how fast can I get a passport for study abroad?",
      a: "Union University students heading to study abroad programs are among our most frequent Jackson clients. Emergency processing delivers passports in 24–48 hours. Standard expedited processing runs 2–9 business days. We also recommend checking student visa requirements for your destination country well in advance.",
    },
    {
      q: "Where do Jackson travelers typically fly internationally?",
      a: "Jackson travelers typically depart from Memphis International Airport (MEM, about 85 miles southwest) for domestic connections, or Nashville International Airport (BNA, about 130 miles east) for more international route options. Both airports are convenient from Jackson via I-40 and require a valid passport book for international flights.",
    },
    {
      q: "Can the Jackson Post Office process my passport application?",
      a: "Yes — the Jackson Main Post Office at 200 Dr Martin Luther King Jr Dr is a USPS passport acceptance facility. They can accept your DS-11 application (for first-time passports, child passports, or if you're not eligible for mail-in renewal). However, they cannot expedite processing. For fastest results, pair your in-person application with Fast Passport Center's courier service.",
    },
    {
      q: "How fast can I get an emergency passport in Jackson?",
      a: "Emergency processing is typically 24–48 hours for Jackson residents. Given Jackson's location at the I-40 crossroads, overnight courier routing to Nashville is highly efficient. Standard expedited processing runs 2–9 business days.",
    },
    {
      q: "Where can I get passport photos in Jackson?",
      a: "Walgreens at 2105 N Highland Ave and CVS at 2034 N Highland Ave in Jackson both offer passport photo services. UPS Store locations in Jackson also provide photo services. Walgreens and CVS are typically open 7 days per week. Always verify your photos meet exact 2x2 inch specifications with a white background before submitting.",
    },
    {
      q: "I need a passport for a medical conference in Europe — how early should I apply?",
      a: "West Tennessee Healthcare professionals attending international conferences should check their passport validity at least 3–4 months before travel. Most European countries require 6 months validity beyond your stay. Fast Passport Center processes renewals in 2–9 business days, so you have some buffer — but don't wait until the week before departure.",
    },
    {
      q: "How do I renew my passport in Jackson?",
      a: "Adult renewals (16 or older, issued within 15 years, same name) can be done entirely by mail with Form DS-82. Fast Passport Center's courier service achieves 2–9 business day turnaround — far faster than standard USPS processing (8–11 weeks). If you're not eligible for mail-in renewal, visit the Jackson Post Office or Madison County Clerk for a DS-11 application.",
    },
    {
      q: "Does the Madison County Clerk's office process passports?",
      a: "Yes. The Madison County Clerk's office at 100 E Main St in downtown Jackson accepts passport applications. They serve as a passport acceptance facility for DS-11 applications. Call (731) 423-6022 to confirm current passport service hours before visiting.",
    },
    {
      q: "Can Fast Passport Center help with Humboldt and Milan residents?",
      a: "Absolutely. We serve all of West Tennessee including Jackson, Humboldt, Milan, Lexington, Henderson, Medina, and the entire Madison County area. Our courier service handles everything — residents of surrounding communities never need to drive to Jackson, Memphis, or Nashville.",
    },
    {
      q: "Is there a difference between the Jackson Post Office and the Madison County Clerk for passport applications?",
      a: "Both the Jackson Main Post Office and the Madison County Clerk's office serve as passport acceptance facilities — they accept DS-11 applications and verify your identity and documents. The main difference is hours and wait times. The County Clerk's office may have shorter lines. Neither facility can expedite processing — that's where Fast Passport Center's courier service comes in.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Jackson North", address: "2105 N Highland Ave, Jackson, TN 38305", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Jackson", address: "2034 N Highland Ave, Jackson, TN 38305", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Jackson", address: "2036 N Highland Ave, Ste B, Jackson, TN 38305", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM" },
    { name: "Walmart Photo — Jackson", address: "2171 S Highland Ave, Jackson, TN 38301", hours: "Mon–Sun: 7AM–9PM" },
    { name: "FedEx Office — Nashville", address: "1801 West End Ave, Nashville, TN 37203", hours: "Mon–Fri: 7AM–11PM, Sat–Sun: 9AM–9PM" },
    { name: "Walgreens — Humboldt", address: "2500 N Central Ave, Humboldt, TN 38343", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "TN Driver Services — Jackson", address: "100 Benchmark Pl, Jackson, TN 38301", hours: "Mon–Fri: 8:30AM–5:00PM", note: "REAL ID, driver's license, and state ID services for Madison County residents. Closest Driver Services Center to Jackson.", featured: true },
    { name: "TN Driver Services — Lexington", address: "17090 US-412, Lexington, TN 38351", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Henderson County and eastern West Tennessee. REAL ID processing available.", featured: false },
    { name: "TN Driver Services — Brownsville", address: "100 S Dupree Ave, Brownsville, TN 38012", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Haywood County and surrounding West Tennessee communities.", featured: false },
  ],
  airports: [
    {
      code: "MEM",
      name: "Memphis International Airport",
      distance: "85 miles southwest of Jackson",
      address: "2491 Winchester Rd, Memphis, TN 38116",
      note: "Closest international airport to Jackson with domestic and limited international routes. About 1 hour 15 minutes southwest via US-45 and I-40. FedEx global hub with connections worldwide.",
      flightUrl: "https://www.flymemphis.com/",
      flightLabel: "MEM Airport",
      featured: true,
    },
    {
      code: "BNA",
      name: "Nashville International Airport",
      distance: "130 miles east of Jackson",
      address: "1 Terminal Dr, Nashville, TN 37214",
      note: "Tennessee's busiest airport with extensive domestic and growing international routes. Co-located with Atlanta Passport Agency — highly convenient for combining airport and agency needs.",
      flightUrl: "https://flynashville.com/",
      flightLabel: "BNA Airport",
      featured: false,
    },
    {
      code: "MKL",
      name: "McKellar-Sipes Regional Airport",
      distance: "7 miles west of Jackson",
      address: "308 Grady Montgomery Dr, Jackson, TN 38301",
      note: "Jackson's local airport with general aviation services. No commercial passenger service. Regional travelers use MEM or BNA for commercial international departures.",
      flightUrl: "https://www.cityofjackson.net/",
      flightLabel: "McKellar-Sipes Airport",
      featured: false,
    },
  ],
};